// extracted by mini-css-extract-plugin
module.exports =  {"cropContainer":"CropModal-module_cropContainer_ffd04","cropSelection":"CropModal-module_cropSelection_ed6a4"};